import React, { Component } from 'react';
import Label from '../ui/forms/Label';
import BoxedNumberInput from '../shared/forms/BoxedNumberInput';
import BoxedInput from '../shared/forms/BoxedInput';
import FormTextWrap from '../ui/forms/FormTextWrap';
import FormWrapper from '../ui/forms/FormWrapper';
import InputWrap from '../ui/forms/InputWrap';
import DoubleWrap from '../ui/forms/DoubleWrap';
import WordWrapParagraph from '../ui/forms/WordWrapParagraph';
import Button from '../ui/Button';

class ApplicationDetails extends Component {
    
    render() { 
        const {   
            kycId,
            price,
            makeModel,
            loanAmount,
            tenure,
            leaseRental,
            interestRate,
            isLease,
            isStage2NextButtonDisabled,
            errorGetApplication
        } = this.props;
        return (
            <>
            <div data-test-id = 'applicationDetails'>
                <FormTextWrap>
                    Please verify your application details.
                </FormTextWrap>
                <FormWrapper>
                    <BoxedInput
                        disabled
                        type="text"
                        onChange={this.handleChange}
                        name="stage2_referenceNo"
                        label="Reference No."
                        value={kycId} />
                    <BoxedNumberInput
                        disabled
                        type="text"
                        value={price}
                        decimalScale={2}
                        thousandSeparator={true}
                        fixedDecimalScale={true}
                        onChange={this.handleChange}
                        label="Price"
                        prefix="SGD"
                        name="stage2_price" />
                    {/* Todo create for div */}
                    <InputWrap>
                        <Label>Make/Model</Label>
                        <WordWrapParagraph
                            disabled
                            name="stage2_make"
                        >{makeModel}
                        </WordWrapParagraph>
                    </InputWrap>
                    {
                        !isLease ?
                            <div>
                                <BoxedNumberInput 
                                    disabled
                                    type="text"
                                    value={loanAmount}
                                    decimalScale={2}
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    onChange={this.handleChange}
                                    label="Loan Amount"
                                    prefix="SGD"
                                    name="stage2_loanAmount" />
                                <DoubleWrap>
                                    <BoxedInput 
                                        disabled
                                        type="text"
                                        onChange={this.handleChange}
                                        label="Loan Tenure (months)"
                                        name="stage2_tenure"
                                        value={tenure} />
                                    <BoxedInput
                                        disabled
                                        type="text"
                                        onChange={this.handleChange}
                                        name="stage2_interestRate"
                                        label="Interest Rate"
                                        value={interestRate} />
                                </DoubleWrap>
                            </div> :
                            <DoubleWrap>
                                <BoxedNumberInput
                                    disabled
                                    type="text"
                                    value={leaseRental}
                                    decimalScale={2}
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                    onChange={this.handleChange}
                                    label="Lease Rental"
                                    name="stage2_tenure" />
                                <BoxedInput
                                    disabled
                                    type="text"
                                    onChange={this.handleChange}
                                    label="Tenure (months)"
                                    name="stage2_interestRate"
                                    value={tenure} />
                            </DoubleWrap>
                    }
                </FormWrapper>
                {
                    <Button
                        disabled={isStage2NextButtonDisabled}
                        onClick={() => !isStage2NextButtonDisabled ? this.props.validateApplicationForm():null}
                        data-test-id="validateApplicationForm"
                        >
                        Next
                    </Button>
                }
                {errorGetApplication !== '' &&
                    <Label isError name="getapplicationerror">
                        {errorGetApplication}
                    </Label>
                }
                </div>
            </>
        );
    };
};

export default ApplicationDetails;